import React, { useState } from "react";
import { Button, Modal, Form, Badge } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { format } from "date-fns";

const CouponValidator = ({ show, onClose, checklist = [] }) => {
  const [coupon, setCoupon] = useState("");
  const [couponData, setCouponData] = useState(null);
  const [couponAmount, setCouponAmount] = useState(0);
  const [errors, setErrors] = useState({});
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  const handleApplyClick = () => {
    let newErrors = {};

    if (!coupon.trim()) {
      newErrors.coupon = "This Field is Required.";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setCouponData(null);
      return;
    }

    setErrors({}); // Clear errors if input is valid

    const filter = { coupon_code: coupon.trim(), coupon_for: 0 };

    axios
      .get(`${baseURL}/coupon/code`, { params: filter })
      .then((response) => {
        if (response.data.data) {
          const data = response.data.data;
          setCouponData(data);

          // Calculate discount amount
          if (data.coupon_type === 0) {
            setCouponAmount(parseFloat(data.coupon_value));
            toast.success("Flat discount coupon applied!");
          } else if (data.coupon_type === 1) {
            const val =
              checklist.reduce(
                (sum, item) => sum + (Number(item.amount) || 0),
                0
              ) * (parseFloat(data.coupon_value) / 100);
            setCouponAmount(val);
            toast.success("Percentage discount coupon applied!");
          }
        } else {
          setCouponData(null);
          setErrors({ coupon: "Coupon not valid" });
        }
      })
      .catch((error) => {
        console.error("Error fetching coupon:", error);
        setCouponData(null);
        setErrors({ coupon: "Error fetching coupon. Please try again." });
      });
  };

  return (
    <Modal show={show} size="lg" onHide={onClose}>
      <div className="modal-content">
        {/* Header */}
        <div className="modal-header" style={{ backgroundColor: "#3ab384" }}>
          <h3 className="modal-title text-white">Coupon Validator</h3>
          <Button
            variant=""
            type="button"
            className="close px-6 py-1"
            onClick={onClose}
          >
            <span className="text-white">×</span>
          </Button>
        </div>

        {/* Body */}
        <div className="modal-body">
          {/* Coupon Code Input */}
          <div className="row mb-3">
            <div className="col-lg-4">
              <Form.Group>
                <Form.Label className="fw-bold text-black">
                  Coupon Code <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter coupon code"
                  value={coupon}
                  onChange={(e) => setCoupon(e.target.value)}
                  isInvalid={!!errors.coupon}
                />
                {errors.coupon && (
                  <div className="text-danger fs-8 mt-1">{errors.coupon}</div>
                )}
              </Form.Group>
            </div>

            <div className="col-lg-2 d-flex align-items-end">
              <Button
                variant="primary"
                className="mb-1"
                onClick={handleApplyClick}
              >
                <i className="bi bi-search"></i> Search
              </Button>
            </div>
          </div>

          {/* Coupon Details Table */}
          {couponData && (
            <div className="table-container">
              <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                <thead>
                  <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                    <th className="min-w-100px text-start">
                      Coupon / Code / Type
                    </th>
                    <th className="min-w-100px text-start">Value</th>
                    <th className="min-w-100px text-start">Start / End Date</th>
                    <th className="min-w-60px text-end">Status</th>
                  </tr>
                </thead>
                <tbody className="text-gray-600 fw-semibold fs-7">
                  <tr>
                    <td className="text-start">
                      <div className="d-flex flex-column">
                        <label className="text-black fw-bold fs-7">
                          {couponData.coupon_name || "-"}{" "}
                          <span className="badge bg-info text-white fs-8 mt-1 align-self-start">
                            {couponData.coupon_type === 0
                              ? "Flat"
                              : "Percentage"}
                          </span>
                        </label>
                        <label className="text-primary fw-semibold fs-8">
                          {couponData.coupon_code || "-"}
                        </label>
                      </div>
                    </td>

                    <td className="text-start text-black">
                      {couponData.coupon_type === 0
                        ? `₹${couponData.coupon_value}`
                        : `${couponData.coupon_value}%`}
                    </td>

                    <td className="text-start">
                      <label className="text-black fw-bold fs-7">
                        {format(new Date(couponData.startdate), "dd-MMM-yyyy")}
                      </label>{" "}
                      /{" "}
                      <label className="text-black fw-bold fs-7">
                        {format(new Date(couponData.enddate), "dd-MMM-yyyy")}
                      </label>
                    </td>

                    <td className="text-end">
                      <Badge
                        bg={couponData.status === 0 ? "primary" : "danger"}
                        className="text-white fs-7 py-1 px-2"
                      >
                        {couponData.status === 0 ? "Active" : "Inactive"}
                      </Badge>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default CouponValidator;
